import React from 'react'
import classNames from 'classnames'
import {oneOf, bool, string, shape} from 'prop-types'

const small = 'small'
const medium = 'medium'

const EnvironmentLabel = ({locale, isProduction, size = small, uniqueId}) => {
  const displayString = isProduction
    ? locale.productionLabel
    : locale.stagingLabel
  return (
    <span
      className={classNames('compassUI-environmentLabel', size)}
      data-test-id={uniqueId}
    >
      {
        (size === 'small')
          ? displayString.substring(0, 4)
          : displayString
      }
    </span>
  )
}

EnvironmentLabel.propTypes = {
  locale: shape({
    productionLabel: string.isRequired,
    stagingLabel: string.isRequired
  }).isRequired,
  isProduction: bool,
  size: oneOf([small, medium]),
  uniqueId: string
}

export default EnvironmentLabel
